<template>
  <div>
    <a-form-model :model="user" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="Email">
        <a-input v-model="user.email" />
      </a-form-model-item>

      <a-form-model-item label="Password">
        <a-input v-model="user.password" type="password" />
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 6, offset: 8 }">
        <a-button type="primary" @click="validate" block>login</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import firebase from "@/configs/firebase-setup";

export default {
  data() {
    return {
      loadingContent: false,
      headers: {
        authorization: "authorization-text"
      },
      labelCol: { span: 7 },
      wrapperCol: { span: 8 },
      user: {
        email: "",
        password: ""
      }
    };
  },

  methods: {
    validate() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.user.email, this.user.password)
        .then(user => {
          this.$router.push({ name: "PostsList" });
        })
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // ...
        });
    }
  }
};
</script>

<style scoped>
#loginBtn {
  width: 100%;
}
</style>